import { createGlobalStyle, css } from 'styled-components'
import { BaseColor, themeColor } from '../palette'
import { rem } from '../utility'
import { breakpointEnding, breakpointStarting, Breakpoint } from '../breakpoints'

const ScrollbarStyle = createGlobalStyle`
  ::-webkit-scrollbar {
    width: ${rem(10)};
    height: ${rem(10)};
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
  }
  ::-webkit-scrollbar-thumb {
    background: ${themeColor(BaseColor.shade_50)};
    border: 1px solid ${themeColor(BaseColor.shade_10)};
    border-radius: ${rem(50)};
    
    &:hover {
      background: ${themeColor(BaseColor.shade_40)};
    }
    &:active {
      background: ${themeColor(BaseColor.shade_30)};
    }
  }
  ::-webkit-scrollbar-track {
    background: ${themeColor(BaseColor.shade_0)};
    border: 0;
  }
  ::-webkit-scrollbar-track:hover {
    background: ${themeColor(BaseColor.shade_0)};
  }
  ::-webkit-scrollbar-track:active {
    background: ${themeColor(BaseColor.shade_0)};
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }

  * {
    scrollbar-color: ${themeColor(BaseColor.shade_50)} ${themeColor(BaseColor.shade_10)};
    scrollbar-width: thin;
  }
`

export default ScrollbarStyle

export const hideScrollbars = css`
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
`

export const hideScrollbarsOnMobile = css`
  @media (${breakpointEnding(Breakpoint.lg)}) {
    ${hideScrollbars};
  }
`

export const hideScrollbarsOnDesktop = css`
  @media (${breakpointStarting(Breakpoint.lg)}) {
    ${hideScrollbars};
  }
`
